import * as React from 'react';
import styles from './countCircle.module.scss';
import { CountCircleProps } from './types';

const { countCircle, red } = styles;

const CountCircle = ({ count }: CountCircleProps) => <><span className='sr-only'>Issues count {count}</span><span aria-hidden='true' className={`${countCircle} ${red}`}>{count}</span></>;

export default CountCircle;
